import { ItemFieldResult } from 'lib/graphql/types/item-field-result';

export const getFieldJsonValue = <T>(
  fields: ItemFieldResult[] | undefined,
  name: string
): T | undefined => fields?.find((f) => f.name === name)?.jsonValue as T | undefined;
